import { PDFDocument, PDFImage } from "pdf-lib/cjs/api";

export const ALLOWED_FILE_TYPES = ["pdf", "png", "jpg", "jpeg"];
export type ALLOWED_FILE_TYPES = "pdf" | "png" | "jpg" | "jpeg";
export interface FileForPdf {
    fileName: string;
    blob: Blob;
    type: ALLOWED_FILE_TYPES;
}

async function embedPdf (buffer: ArrayBuffer, pdfDoc: PDFDocument) {
    const sourcePdf = await PDFDocument.load(buffer);
    const embedPages = await pdfDoc.embedPages(sourcePdf.getPages());
    for (const embed of embedPages) {
        const page = pdfDoc.addPage();
        const dims = embed.scale(1);
        const maxWidth = page.getWidth();
        const maxHeight = page.getHeight();
        let width = dims.width;
        let height = dims.height;
        if (width > maxWidth) {
            height = height / width * maxWidth;
            width = width / width * maxWidth;
        } else if (height > maxHeight) {
            width = width / height * maxHeight;
            height = height / height * maxHeight;
        }
        page.drawPage(embed, {
            width: width,
            height: height
        });
    }
    return;
}

async function embedImage (buffer: ArrayBuffer, embedder: (png: string | ArrayBuffer | Uint8Array) => Promise<PDFImage>, pdfDoc: PDFDocument) {
    const page = pdfDoc.addPage();
    const embed = await embedder(buffer);
    const dims = embed.scale(1);
    const maxWidth = page.getWidth() * 0.9;
    const maxHeight = page.getHeight() * 0.9;
    let width = dims.width;
    let height = dims.height;
    if (width > maxWidth) {
        height = height / width * maxWidth;
        width = width / width * maxWidth;
    } else if (height > maxHeight) {
        width = width / height * maxHeight;
        height = height / height * maxHeight;
    }

    const x = (page.getWidth() / 2) - (width / 2);
    const y = (page.getHeight() / 2) - (height / 2);
    return page.drawImage(embed, {
        x: x >= 0 ? x : 0,
        y: y >= 0 ? y : 0,
        width: width,
        height: height,
    });
}

export async function combinePdf(
    files: FileForPdf[]
): Promise<string> {
    const newPdf = await PDFDocument.create();
    for (const file of files) {
        const arrayBuffer = await getArrayBuffer(file.blob);
        const index = files.findIndex(x => x.fileName === file.fileName);
        switch (file.type) {
            case "jpeg":
            case "jpg":
                await embedImage(arrayBuffer, newPdf.embedJpg.bind(newPdf), newPdf);
                break;
            case "png":
                await embedImage(arrayBuffer, newPdf.embedPng.bind(newPdf), newPdf);
                break;
            case "pdf":
                await embedPdf(arrayBuffer, newPdf);
                break;
            default:
                throw new Error("Not knowing to handle this kind of file");
        }
    }
    return newPdf.saveAsBase64({ dataUri: true });
}

async function getArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function () {
            resolve(reader.result as ArrayBuffer);
        };
        reader.onerror = (err) => {
            reject(err);
        };
    });
}



// WEBPACK FOOTER //
// ./src/QuestionUtils/PDFTools.ts